import type { StyleFunctionProps } from '@chakra-ui/theme-tools';
import { mode } from '@chakra-ui/theme-tools';

import scrollbar from './foundations/scrollbar';
import addressEntity from './globals/address-entity';
import getDefaultTransitionProps from './utils/getDefaultTransitionProps';

const global = (props: StyleFunctionProps) => ({
  body: {
    bg: mode('white', 'black')(props),
    backgroundImage: mode(
      'none',
      'radial-gradient(circle at 14% -8%, rgba(255, 185, 54, 0.18), transparent 30%), radial-gradient(circle at 86% 6%, rgba(255, 122, 26, 0.16), transparent 32%), radial-gradient(circle at 50% 110%, rgba(245, 90, 0, 0.12), transparent 38%), linear-gradient(180deg, #050302 0%, #0D0704 46%, #050302 100%)',
    )(props),
    backgroundAttachment: 'fixed',
    ...getDefaultTransitionProps(),
    '-webkit-tap-highlight-color': 'transparent',
    'font-variant-ligatures': 'no-contextual',
  },
  'body.chakra-ui-dark::before': {
    content: '""',
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    opacity: 0.82,
    backgroundImage: [
      'radial-gradient(circle, rgba(255, 216, 122, 0.62) 0 1px, transparent 2px)',
      'radial-gradient(circle, rgba(255, 122, 26, 0.48) 0 1px, transparent 2px)',
      'radial-gradient(circle at 18% 24%, rgba(255, 185, 54, 0.16), transparent 18%)',
      'radial-gradient(circle at 80% 16%, rgba(240, 90, 0, 0.14), transparent 20%)',
    ].join(', '),
    backgroundSize: '220px 220px, 340px 340px, 100% 100%, 100% 100%',
    backgroundPosition: '0 0, 80px 140px, 0 0, 0 0',
    animation: 'elvorFloatLights 28s linear infinite',
  },
  'body.chakra-ui-dark::after': {
    content: '""',
    position: 'fixed',
    inset: 0,
    zIndex: 0,
    pointerEvents: 'none',
    background: 'linear-gradient(180deg, rgba(5, 3, 2, 0.08), rgba(5, 3, 2, 0.72))',
  },
  '#__next': {
    position: 'relative',
    zIndex: 1,
  },
  'body.chakra-ui-dark': {
    color: 'rgba(255, 246, 232, 0.92)',
  },
  'body.chakra-ui-dark header, body.chakra-ui-dark footer': {
    backdropFilter: 'blur(18px)',
  },
  mark: {
    bgColor: mode('green.100', 'green.800')(props),
    color: 'inherit',
  },
  'svg *::selection': {
    color: 'none',
    background: 'none',
  },
  form: {
    w: '100%',
  },
  '@keyframes elvorFloatLights': {
    '0%': {
      backgroundPosition: '0 0, 80px 140px, 0 0, 0 0',
      filter: 'brightness(1)',
    },
    '50%': {
      backgroundPosition: '180px -260px, -120px 320px, 0 0, 0 0',
      filter: 'brightness(1.22)',
    },
    '100%': {
      backgroundPosition: '360px -520px, -320px 500px, 0 0, 0 0',
      filter: 'brightness(1)',
    },
  },
  ...scrollbar(props),
  ...addressEntity(props),
});

export default global;
